<template>
  <div class="">
    <span class="row-status" :class="calClass">
      {{ eventStatus }}
    </span>
  </div>
</template>

<script>
  import constants from '../../_consts';

  export default {
    name: 'Row-Status',
    props: {
      eventStatus: {
        type: String
      }
    },
    data () {
      return {
        rowStatus: {}
      }
    },
    computed: {
      calClass () {
        let status = this.eventStatus.toLowerCase();
        if (status === constants.eventStatus.drafts.toLowerCase()) {
          return 'row-status-color-grey'
        }
        if (status === constants.eventStatus.submitted) {
          return 'row-status-color-light-blue'
        }
        if (status === constants.eventStatus.review) {
          return 'row-status-color-red'
        }
        if (status === constants.eventStatus.approved) {
          return 'row-status-color-green'
        }
        if (status === constants.eventStatus.archived) {
          return 'row-status-color-brown'
        }
      }
    },
    mounted: function () {
    }
  }
</script>

<style lang="less">
  @import '~@/styles/variables.less';
  @import '~@/styles/customstyle.less';
  .row-status{
    color: @white;	
    font-family: @font-family-main;	
    font-size: 9px;	
    font-weight: bold;	
    line-height: 12px;
    text-transform: uppercase;
    padding: 2px 10px 2px 10px;
    border-radius: 100px;
  }
  .row-status-color-grey{
    background-color: @grey-3
  }
  .row-status-color-light-blue{
    background-color: @light-blue
  }
  .row-status-color-red{
    background-color: @red
  }
  .row-status-color-green{
    background-color: @green
  }
  .row-status-color-brown{
    background-color: @brown
  }
</style>



// WEBPACK FOOTER //
// RowStatus.vue?1f34ec1b